import {getDatadogRum} from '../../../../util/datadog/datadogRum';
import {BucketedLine} from '../../types';
import {
  GroupedBackendLinesQueryRuns,
  GroupedBucketedQueryRuns,
  GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

export function isAggregatedRuns(
  runs:
    | GroupedBucketedQueryRuns
    | GroupedBackendLinesQueryRuns
    | null
    | undefined
): runs is GroupedBucketedQueryRunWithGroupedRunConnection {
  return runs?.__typename === 'GroupedRunConnection';
}

export function profileRenderTimeSaved(
  runsById: Record<string, BucketedLine>,
  type: 'backend' | 'grouped'
) {
  const DD_RUM = getDatadogRum();
  try {
    const numPoints = Object.values(runsById).reduce((acc, run) => {
      const hPoints = (run.historyLines ?? []).reduce((ac, line) => {
        return ac + line.historyLine.length;
      }, 0);
      return acc + hPoints;
    }, 0);
    DD_RUM.addAction('Backend_line_render_saved', {
      numRuns: Object.keys(runsById).length,
      numPoints,
      type,
    });
  } catch (e) {
    DD_RUM.addError(new Error('backend lines profiling error'), {
      reason: 'Error profiling backend lines',
      error: e,
    });
    return;
  }
}
